import { createFileRoute, redirect } from "@tanstack/react-router";

/** Folded into the editor's Bindings panel. The old address keeps resolving. */
export const Route = createFileRoute("/console/spaces/$joinCode/bindings")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/console/spaces/$joinCode/control",
      params: { joinCode: params.joinCode },
      search: { panel: "bindings" },
    });
  },
});
